export default __webpack_public_path__ + "eb69c71221d4cadbc73e0f252b58adb0.png";